import { Component } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ProjetIndicateur } from 'src/app/shared/models/projet';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import { Constant } from 'src/app/shared/service/utils/contant';
import * as FileSaver from 'file-saver';
import { DetailTepRapportComponent } from './detail-tep-rapport/detail-tep-rapport.component';

@Component({
  selector: 'app-rapport-performance',
  templateUrl: './rapport-performance.component.html',
  styleUrl: './rapport-performance.component.scss'
})


export class RapportPerformanceComponent {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;

  projetData: any = [] = [];
  annee: any;
  modalRef: NgbModalRef | null = null;
  isLoading: boolean = false;
  searchTerm: string = '';

  itemToDelete!: ProjetIndicateur;
  filteredtems: any = [];
  projetId: any
  pageSize: number = 10;
  pdfUrl: string;
  excelUrl: string;

  firstProjets: number = 0; // La page actuelle (commence à 0)
  rowsProjets: number = 10; // Nombre d'éléments par page
  totalRecords: number = 0; // Nombre total d'éléments
  paginatedProjets: any = [];
  dateDebut: string;
  dateFin: string;
  projetItems: any = [];
  selectedProjet: any;
  directionId: any;
  showFiltre: boolean = false;
  directionItems: any = [];
  userInfo: any;

  chartData: any;
  chartOptions: any;
  constructor(
    private modalService: NgbModal,
    public formBuilder: UntypedFormBuilder,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {
   
  }

  ngOnInit(): void {

    this.projetId = this.localstorage.getProjetToUser();
    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();
    const today = new Date();
    
     const exercice = this.localstorage.getExerciceToUserToSuivieEvaluation();

    this.dateDebut = `${exercice}-01-01`;
    this.dateFin = new Date().toISOString().split('T')[0];

    this.userInfo = this.localstorage.getInfoUserToService();

    //recuperons la liste des projets (quel que soit le profil)
    this.getProjetList(this.userInfo?.data?.reference);

    if (this.userInfo?.data?.groupe === "admin") {
      this.showFiltre = true;
      //this.getDirection();
    }
    if (this.userInfo?.data?.groupe === "point_focal") {
      this.directionId = this.localstorage.getInfoUserToService()?.data?.direction_id;
    }

    //recup liste donnees par defaut au chargement
    this.getStatistiqueProjetsByProgramme();
   
   this.initChart();
  }

  initChart() {
    this.chartData = {
      labels: ['TEP Prévu', 'TEP Réalisé', 'Écart'],
      datasets: [
        {
          label: 'TEP Prévu',
          backgroundColor: '#42A5F5',
          data: [0, 0, 0] 
        },
        {
          label: 'TEP Réalisé',
          backgroundColor: '#66BB6A',
          data: [0, 0, 0] 
        },
        {
          label: 'Écart',
          backgroundColor: '#FF7043',
          data: [0, 0, 0] 
        }
      ]
    };
  
    this.chartOptions = {
      responsive: true,
      scales: {
        x: { // Replaced xAxes
          beginAtZero: true
        },
        y: { // Replaced yAxes
          beginAtZero: true
        }
      }
    };
  }
  
  getDirection() {

    this.paramservice.fetchDataDirection().subscribe(

      (response: any) => {

        ////console.log("la reponse du webservice", response);

        this.directionItems = response.data;

      },
      (error) => {

        ////console.log("une erreur est survenu", error);

      }
    )
  }

  //liste des projets
  getProjetList(userReference: any) {

    this.paramservice.getProgramme().subscribe(

      (response: any) => {

        this.projetItems = response.data;
        // this.getExercice();

        ////console.log("la reponse du webservice", this.projetItems);
      },
      (error: any) => {
        ////console.log("une erreur est survenu", error);

      }
    )
  }

  //Get Statistiques ProjetByProgramme
  getStatistiqueProjetsByProgramme() {
    //check
    if (this.dateDebut === null || this.dateDebut === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (this.dateFin === null || this.dateFin === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }
    let projectItem: any = {};
    if (this.selectedProjet === "DEFAULT") {
      projectItem = null;
    } else {
      projectItem = this.selectedProjet;
    }

    this.isLoading = true;
    this.ngxService.start();

    this.paramservice.getStatistiqueProgrammeProjet(this.annee, projectItem, this.directionId, this.dateDebut, this.dateFin, this.userInfo?.data?.reference).subscribe(
      (response: any) => {
        this.ngxService.stop();

        this.isLoading = false;
        this.projetData = response.data; // 
        ////console.log('this.projetData', this.projetData);

        this.totalRecords = this.projetData.length;

        this.updatePaginatedProjets();
        this.updateChart(); // Mettre à jour l'histogramme avec les nouvelles données

      },
      (error) => {
        this.ngxService.stop();

        this.isLoading = false;
        ////console.log('une erreur est survenue', error);
      }
    );
  }//end getStatistiqueProjetsByProgramme


  updateChart(): void {
    if (this.projetData.length > 0) {
      const projet = this.projetData[0]; 
  
      this.chartData = {
        labels: ['TEP Prévu', 'TEP Réalisé', 'Écart'], 
        datasets: [
          {
            label: 'TEP Prévu',
            backgroundColor: '#42A5F5',
            data: [projet.tep_prevu, 0, 0]
          },
          {
            label: 'TEP Réalisé',
            backgroundColor: '#66BB6A',
            data: [0, projet.tep_realise, 0] 
          },
          {
            label: 'Écart',
            backgroundColor: '#FF7043',
            data: [0, 0, projet.ecart] 
          }
        ]
      };
    }
  }
  

  
  onPageChangeProjets(event) {
    this.firstProjets = event.page * this.rowsProjets;
    this.updatePaginatedProjets();
  }

  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.projetData.slice(start, end);

  }
  exportToDocument(typeDoc: any) {
     //check
     if (this.dateDebut === null || this.dateDebut === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (this.dateFin === null || this.dateFin === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }
    let projectItem: any = {};
    if (this.selectedProjet === "DEFAULT") {
      projectItem = null;
    } else {
      projectItem = this.selectedProjet;
    }
    this.ngxService.start();
   

    this.paramservice.getStatistiqueProgrammeProjetPrint(this.annee, projectItem, this.directionId, this.dateDebut, this.dateFin, this.userInfo.data.reference, typeDoc,).subscribe(
      (response: Blob) => {
        const filename = 'Tef_Projet_Programmes.pdf';
        FileSaver.saveAs(response, filename);

        const url = URL.createObjectURL(response);
        window.open(url, '_blank');

        this.ngxService.stop();
        this.messageService.add({ severity: 'success', summary: 'Téléchargement réussi', detail: 'Le fichier PDF a été téléchargé avec succès', life: 3000 });
      },
          (error: any) => {
        this.ngxService.stop();

        if (error.error instanceof Blob) {

          const reader = new FileReader();

          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result as string);

              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: err.message || 'Téléchargement échoué'
              });

            } catch (e) {
              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Erreur lors du traitement du message'
              });
            }
          };

          reader.readAsText(error.error);

        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.error?.message || 'Téléchargement échoué'
          });
        }
      }
    );

  }


    detailsProjet(item: any) {
  
      this.localstorage.saveTepProjet(item);
  
      const date = {
        date_debut: this.dateDebut,
        date_fin: this.dateFin
      }
      this.localstorage.saveDateToDetail(date);

      const modalRef = this.modalService.open(DetailTepRapportComponent, {
        backdrop: 'static',
        centered: true,
        size: 'xl'
      },);
    }//end detailsProjet





}